<div>
  <div class='unprocessed' [class.processed]="processed">
    <h2 id="title"></h2>
    <div id="doc"></div>
  </div>
</div>
